import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    InputSignal,
    Signal,
    signal,
    WritableSignal,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: "app-timer",
    standalone: true,
    imports: [CommonModule, FontAwesomeModule],
    templateUrl: "./timer.component.html",
    styleUrls: ["./timer.component.scss"],
})
export class TimerComponent {
    public time: InputSignal<Date | string> = input.required<Date | string>();
    private now: WritableSignal<Date> = signal(new Date());
    private differenceMs: Signal<number> = computed(() => {
        const targetTime = new Date(this.time());
        return targetTime.getTime() - this.now().getTime();
    });
    public isPast: Signal<boolean> = computed(() => this.differenceMs() < 0);
    public formattedDifference: Signal<string> = computed(() => {
        let diffMs = Math.abs(this.differenceMs());
        const hours = Math.floor(diffMs / 3600000);
        diffMs %= 3600000;
        const minutes = Math.floor(diffMs / 60000);
        diffMs %= 60000;
        const seconds = Math.floor(diffMs / 1000);
        return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    });

    constructor() {
        setInterval(() => {
            this.now.set(new Date());
        }, 1000);
    }
}
